module.exports = __webpack_public_path__ + "img/07.8d9efe71.png";